export default "__VITE_ASSET__98e9b265__"